/* This file is autogenerated, see readme.md for instructions */
import PictureAltSvgIcon from '@bloomreach/banana-theme/icons/picture-alt.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PictureAltIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PictureAltSvgIcon />
    </Icon>
  );
});

PictureAltIcon.displayName = 'PictureAltIcon';

export default PictureAltIcon;
